import { makeStyles, createStyles } from 'raydiant-elements/styles';
import { Theme } from 'raydiant-elements/theme';
import { textTruncate } from 'raydiant-elements/mixins';
import { FC } from 'react';
import raydialTheme from '../../raydialTheme';

interface AccountTableProps {}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      '& th': {
        width: '50%',
        fontWeight: 400,
        textAlign: 'left',
        padding: theme.spacing(0.5, 0),
        paddingRight: theme.spacing(0.25),
        color: raydialTheme.gray600,
        fontSize: 16,
        ...textTruncate(),
      },

      '& td': {
        fontSize: theme.fontSizes.md,
        width: '50%',
        padding: theme.spacing(0.25, 0),
        color: raydialTheme.gray600,
      },

      '& th + td': {
        paddingLeft: theme.spacing(0.25),
      },
    },
  }),
);

const AccountTable: FC<AccountTableProps> = ({ children }) => {
  const classes = useStyles();
  return <table className={classes.root}>{children}</table>;
};

export default AccountTable;
